import { Component, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CLIENT_AREA_URL, NAV_ITEMS } from '../nav-items';

/** Menu mobile (aberto pelo botão do `app-header-main`). Fecha ao clicar em qualquer link. */
@Component({
  selector: 'app-header-menu',
  imports: [RouterLink],
  templateUrl: './header-menu.html',
  styleUrl: './header-menu.scss',
})
export class HeaderMenu {
  readonly closed = output<void>();

  protected readonly items = NAV_ITEMS;
  protected readonly clientAreaUrl = CLIENT_AREA_URL;
}
